import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseSidebarActivityComponent } from '../base-sidebar-activity/base-sidebar-activity.component';
import { VizService } from 'src/app/common/services/viz/viz.service';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { Router } from '@angular/router';
import { MEActivityService } from 'src/app/common/activities/me-activity.service';
import { VizAliasStatus } from 'src/app/common/services/viz/viz';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';
import { combineLatest } from 'rxjs';
import { hasOnePermission, hasPermission, InternalSettingsService } from 'src/app/common/services/internal-settings/internal-settings.service';
import { PermissionList } from 'src/app/common/services/internal-settings/internal-settings.interface';


@Component({
	selector: 'app-viz-sidebar-activity',
	templateUrl: './viz-sidebar-activity.component.html',
	styleUrls: ['./viz-sidebar-activity.component.less'],
	standalone: false
})
export class VizSidebarActivityComponent extends BaseSidebarActivityComponent {

	constructor(
		private srvViz: VizService,
		srvIS: InternalSettingsService,
		srvES: ExternalSettingsService,
    router: Router,
    srvActivity: MEActivityService,
    cd: ChangeDetectorRef,
		translate: TranslateUtilityService) {
		super(srvIS, srvES, router, srvActivity, cd, translate)
	}

	override navigateTo() {
		this.srvViz.getVizAliasInfo().subscribe((vizAliasInfo)=>{
			if (vizAliasInfo) {
				if (vizAliasInfo.status == VizAliasStatus.DISABLED) {
					if (hasOnePermission([PermissionList.ACCESS_REACTIVATE_VIZ_ALIAS], this.is.permissions)) this.srvViz.showReviewDialog();
					else this.srvViz.showContactDialog();
					return;
				}
				if (hasPermission(PermissionList.ACCESS_MANAGE_VIZ_PAYEES, this.is.permissions)) {
					this.srvViz.getPayeesList();
				}

				this.srvViz.getVizCards().subscribe((cards)=>{
					if (this.activity.path !== this.getCurrentUrl()) {
						this.srvActivity.reset();
						this.router.navigateByUrl(this.activity.path || '/dashboard');
					}
				})
			} else {
				// May need something here
			}
			
			if (this.activity.path !== this.getCurrentUrl()) {
				this.srvActivity.reset();
				this.router.navigateByUrl(this.activity.path || '/dashboard');
			}
		})

  }

	

}
